function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @param {SystemStyleObject} provided -- The component's default Chakra styles
 * @param {Object} state -- The component's current state e.g. `isFocused` (this gives all of the same props that are passed into the component)
 * @returns {SystemStyleObject} An output style object which is forwarded to the component's `sx` prop
 */
export var Variant;

(function (Variant) {
  Variant["DARK"] = "dark";
  Variant["DEFAULT"] = "default";
  Variant["LIGHT"] = "light";
  Variant["OUTLINE"] = "outline";
})(Variant || (Variant = {}));

export var menuBase = {
  menu: provided => _extends({}, provided, {
    bg: 'white',
    shadow: 'base'
  }),
  menuList: provided => _extends({}, provided, {
    bg: 'white'
  }),
  option: provided => _extends({}, provided, {
    color: 'black',
    bg: 'white',
    _active: {
      color: 'white',
      bg: 'brand.300',
      fontWeight: 'bold'
    },
    _expanded: {
      color: 'white',
      bg: 'brand.500',
      fontWeight: 'bold'
    },
    _hover: {
      color: 'black',
      bg: 'gray.200'
    },
    _selected: {
      color: 'white',
      bg: 'brand.500',
      fontWeight: 'bold'
    }
  })
};
export var variantLight = _extends({}, _extends({}, menuBase));
export var variantOutline = _extends({
  container: provided => _extends({}, provided, {
    borderWidth: '1px',
    borderRadius: 'base',
    borderColor: 'gray.200'
  }),
  control: provided => _extends({}, provided, {
    border: 'none',
    borderColor: 'transparent'
  }),
  placeholder: provided => _extends({}, provided, {
    px: 1
  }),
  singleValue: provided => _extends({}, provided, {
    px: 1
  }),
  inputContainer: provided => _extends({}, provided, {
    px: 1
  })
}, _extends({}, menuBase));
export var variantDark = {
  input: provided => _extends({}, provided, {
    color: 'blue.100'
  }),
  singleValue: provided => _extends({}, provided, {
    color: 'blue.100'
  }),
  placeholder: provided => _extends({}, provided, {
    color: 'blue.100'
  }),
  dropdownIndicator: provided => _extends({}, provided, {
    color: 'blue.100'
  }),
  control: provided => _extends({}, provided, {
    bg: 'transparent',
    borderColor: 'blue.100'
  }),
  item: provided => _extends({}, provided, {
    _active: {
      bg: 'blue.100'
    },
    _expanded: {
      bg: 'blue.100'
    }
  })
};
export var variants = {
  outline: variantOutline,
  dark: variantDark,
  light: variantLight,
  default: {}
};
//# sourceMappingURL=variants.js.map